module.exports = __webpack_public_path__ + "img/pay.8e77c28a.png";